"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var getCSSRules = function (_a, _b) {
    var colors = _a.colors;
    var customColors = _b.colors, percentage = _b.percentage;
    return ({
        stroke: {
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
            height: 4,
            backgroundImage: "linear-gradient(90deg, \n    ".concat(customColors ? customColors[0] : colors.Faceman.default, " 25%, \n    ").concat(customColors ? customColors[1] : colors.Hannibal[500], " 62%,\n    ").concat(customColors ? customColors[2] : colors.Baracus.default, " 80%)"),
            width: "".concat(percentage !== undefined ? percentage : 100, "%"),
        },
    });
};
var GradientStroke = function (props) {
    var theme = (0, react_1.useTheme)();
    var styles = getCSSRules(theme, props);
    return (0, jsx_runtime_1.jsx)("div", { css: styles.stroke }, void 0);
};
exports.default = GradientStroke;
//# sourceMappingURL=index.js.map